import { Injector, PipeTransform } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { LocalizationService } from '@abp/localization/localization.service';
var LocalizePipe = /** @class */ (function () {
    function LocalizePipe(injector) {
        this.localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
        this.localization = injector.get(LocalizationService);
    }
    LocalizePipe.prototype.l = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        args.unshift(key);
        args.unshift(this.localizationSourceName);
        return this.ls.apply(this, args);
    };
    LocalizePipe.prototype.ls = function (sourcename, key) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var localizedText = this.localization.localize(key, sourcename);
        if (!localizedText) {
            localizedText = key;
        }
        if (!args || !args.length) {
            return localizedText;
        }
        args.unshift(localizedText);
        return abp.utils.formatString.apply(this, this.flattenDeep(args));
    };
    LocalizePipe.prototype.transform = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.l(key, args);
    };
    LocalizePipe.prototype.flattenDeep = function (array) {
        var _this = this;
        return array.reduce(function (acc, val) {
            return Array.isArray(val) ?
                acc.concat(_this.flattenDeep(val)) :
                acc.concat(val);
        }, []);
    };
    return LocalizePipe;
}());
export { LocalizePipe };
